<template>
  <v-card
    v-if="shouldRenderAlert"
    style="border-left: 8px solid #ff5252; background: #ffebee"
  >
    <v-row no-gutters class="d-flex align-center">
      <v-col cols="12" sm="12" md="12">
        <v-card-text class="pb-2 d-flex pt-2 pt-md-4">
          <v-icon color="red" class="pa-2 mr-4 d-none d-md-flex">
            mdi-alert-outline
          </v-icon>
          <div
            class="d-flex justify-space-between flex-column"
            style="width: -webkit-fill-available"
          >
            <div class="d-flex justify-space-between align-center">
              <h1
                class="text-subtitle-1 text-md-h6 font-weight-bold"
                style="line-height: 20px"
              >
                {{ rejectedTitle }}
              </h1>
              <v-btn @click="hideExcludedAlert()" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>

            <span
              v-html="mainMessage"
              class="text-subtitle-2 text-md-subtitle-1 grey--text text--darken-1 mt-2 letter-main-message pr-7"
            >
            </span>

            <span
              class="text-subtitle-2 text-md-subtitle-1 grey--text text--darken-1 mt-2 letter-sub-message pr-7"
            >
              No te preocupes, nuestro equipo de administración se comunicará
              con vos para corregir la situación.
            </span>

            <div>
              <v-btn
                color="red"
                class="custom-transform-class text-none px-0 mt-4"
                style="letter-spacing: 0.08px"
                text
                @click="viewBillDetails(bill.id)"
              >
                Ver detalle de la factura
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "BillErrorAlert",
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isAlertVisible: false,
    };
  },
  created() {
    const hiddenKey = `hidden-alert-bill-${this.bill.id}`;
    const storedValue = localStorage.getItem(hiddenKey);

    if (storedValue === "hidden") {
      this.isAlertVisible = false;
    } else {
      this.isAlertVisible = true;
      localStorage.setItem(hiddenKey, "visible");
    }
  },
  computed: {
    rejectedTransactions() {
      const transactions = this.bill?.transacciones || [];
      return transactions.filter((t) => Number(t.status) === 5);
    },
    showRejectedNotification() {
      return this.rejectedTransactions.filter(
        (t) => t.show_rejected_notify ?? true
      );
    },
    alertItems() {
      const items = this.showRejectedNotification.length
        ? this.showRejectedNotification
        : this.rejectedTransactions;

      return [...items].sort((a, b) =>
        String(this.getRequestId(a)).localeCompare(String(this.getRequestId(b)))
      );
    },
    shouldRenderAlert() {
      if (!this.isAlertVisible) return false;
      if (this.alertItems.length > 0) return true;
      return Boolean(this.bill?.have_transaction_rejected);
    },
    rejectedTitle() {
      if (this.alertItems.length <= 1) {
        return "Se excluyó un servicio facturado";
      }
      return "Se excluyeron varios servicios de una factura";
    },
    invoiceLabel() {
      return (
        this.bill?.invoice_number ||
        this.bill?.numero_factura ||
        this.alertItems[0]?.invoice_number ||
        this.bill?.id ||
        ""
      );
    },
    mainMessage() {
      const items = this.alertItems;

      if (!items.length) {
        return `Hay servicios excluidos en la <strong>Fact. ${this.invoiceLabel}</strong>. Podrás ver los motivos ingresando al detalle de la factura.`;
      }

      if (items.length === 1) {
        const t = items[0];
        const motivo = t.comment || t.reject_reason || "Sin motivo informado";
        return `Se excluyó el servicio <strong>${this.formatServiceLabel(
          t
        )}</strong> de la <strong>Fact. ${this.invoiceLabel}</strong>.<br><strong>Motivo:</strong> ${motivo}.`;
      }

      const labels = items.map((t) => this.formatServiceLabel(t));
      const lastLabel = labels.pop();
      const formatted =
        labels.length > 0 ? `${labels.join(", ")} y ${lastLabel}` : lastLabel;

      return `Se excluyeron los servicios <strong>${formatted}</strong> de la <strong>Fact. ${this.invoiceLabel}</strong>. Podrás ver los motivos ingresando al detalle de la factura.`;
    },
  },
  methods: {
    getRequestId(transaction) {
      const value = transaction?.request_id ?? transaction?.request ?? null;

      if (value && typeof value === "object") {
        return value.id ?? value.request_id ?? "";
      }

      return value ?? "";
    },
    formatServiceLabel(transaction) {
      const requestId = this.getRequestId(transaction);
      const serviceName = transaction?.service || "Servicio";
      return requestId ? `${serviceName} (Ped. ${requestId})` : serviceName;
    },
    viewBillDetails(id) {
      this.$router.push({ name: "bill-details", params: { id } });
    },
    hideExcludedAlert() {
      const key = `hidden-alert-bill-${this.bill.id}`;
      localStorage.setItem(key, "hidden");
      this.isAlertVisible = false;
      this.$emit("hidden", this.bill.id);
    },
  },
};
</script>
<style scoped>
.letter-main-message {
  line-height: 24px;
  letter-spacing: 0.08px;
}
.letter-sub-message {
  font-size: 14px;
  line-height: 20px;
  font-style: italic;
}

@media (max-width: 600px) {
  .letter-main-message {
    line-height: 20px;
    line-height: 18px;
  }
  .letter-sub-message {
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
